<template>
    <div class="legal_detial_new" v-loading="loading">
        <div class="r_banner">
            <div class="banner_title">推荐律师</div>

            <div class="change_box">
                <div class="change_item" :class="{ 'change_item_ac': banner_ac == index }"
                    v-for="(item, index) in $store.state.vuex_lawyers" :key="index"></div>
            </div>
            <el-carousel :autoplay="true" :indicator-position="'none'" @change="change_banner">
                <el-carousel-item v-for="(item, index) in $store.state.vuex_lawyers" :key="index">
                    <div class="banner_box">
                        <div class="borders_box">
                            <div class="borders1"></div>
                            <div class="borders2">
                                <!-- <img src="@/assets/img/index/legal/user_img.png" alt=""> -->
                                <img :src="item.business_img" alt="">

                            </div>
                            <div class="tage_box"  v-if="item.elite==1">
                                <div class="tages">金牌律师</div>
                            </div>
                        </div>
                        <div class="ls_name">{{item.name}}律师</div>
                        <div class="ls_texts">{{minx_get_causeIds(item.causeIds)}}</div>
                        <div class="btns_flex">
                            <div class="btns" @click="$router.push('/lawyer_detial?id='+item.id)">
                                <img src="@/assets/img/index/legal/icons1.png" alt="">

                                快速咨询
                            </div>
                        </div>
                    </div>
                </el-carousel-item>
            </el-carousel>
        </div>
        <!-- r_top_bg2.png -->
        <div class="r_banner2">
            <div class="img_text">
                <img src="../../assets/img/index/legal/r_top_bg2_icon.png" alt="">
                免费报价
            </div>
            <div class="textx1">
                一键智能评估案件费用
            </div>
            <div class="btns">
                马上计算
            </div>
        </div>
        <div class="r_banner3">
            <div class="banner_title">推荐服务</div>

            <div class="change_box">
                <div class="change_item" :class="{ 'change_item_ac': banner_ac2 == index }"
                    v-for="(item, index) in banner_list2" :key="index"></div>
            </div>
            <!-- <div @click="handle_detial(banner_ac2)"> -->
                <el-carousel :autoplay="true" :indicator-position="'none'" @change="change_banner2" >
                    <el-carousel-item v-for="(item, index) in banner_list2" :key="index" >
                        <div class="banner_box" @click="handle_detial(item)">
                            <div class="banner_imgs" >
                                <!-- <img src="../../assets/img/index/legal/bg1.png" alt=""> -->
                                <img :src="item.thumb" alt="">
                            </div>
                            <div class="banner_texts">{{ item.title }}</div>
                            <div class="banner_tages">
                                <div class="tages" v-if=" (item.cate1||{}).title">{{ (item.cate1||{}).title }}</div>
                                        <div class="tages" v-if=" (item.cate2||{}).title">{{ (item.cate2||{}).title }}</div>
                                        <div class="tages" v-if=" (item.cate3||{}).title">{{ (item.cate3||{}).title }}</div>
                            </div>
                            <div class="price_flex">
                                <div class="prices">{{ item.price }}</div>
                                <div class="nums">销量 {{ item.sale_num }}</div>
                            </div>
                        </div>
                    </el-carousel-item>
                </el-carousel>
            <!-- </div> -->
           
        </div>
    </div>
</template>
<script>
import {
    mapState
} from 'vuex'



export default {
    components: {

    },
    name: "homes",
    data() {
        return {
            loading: false,
            banner_ac: 0,
            banner_list: [1, 2, 3],
            banner_ac2: 0,
            banner_list2: []
        }
    },
    computed: {

    },
    watch: {

    },
    created() {
        this.get_list()

    },
    methods: {
        change_banner(e) {
            // console.log('却换触发',e)
            this.banner_ac = e
        },
        change_banner2(e) {
            // console.log('却换触发',e)
            this.banner_ac2 = e
        },
        handle_detial(item){
            console.log(item)
            this.$router.push({
                path:'/individual_detial',
                query:{
                    id:item.id
                }
            })
        },
        get_list(){
            this.loading=true
            this.$api("servePros", {
				 
			}, "get").then((res) => {
                this.loading = false
                console.log('个人法务',res)
                if (res.code == 1) {
                    this.banner_list2=res.data.data
                   
                } else {
                    alertErr(res.msg)
                }
            });
        },
    },

}
</script>
<style scoped lang="less">
.legal_detial_new {
    width: 420px;
    min-height: 100px;
    .r_banner {
        width: 420px;
        height: 460px;
        // background: red;
        // margin-top: 24px;
        position: relative;

        .banner_title {
            position: absolute;
            top: 24px;
            left: 32px;
            display: flex;
            align-items: center;
            z-index: 100;
            font-weight: bold;
            font-size: 18px;
            color: #333333;
        }

        .change_box {
            position: absolute;
            top: 32px;
            right: 32px;
            display: flex;
            align-items: center;
            z-index: 100;

            .change_item {
                width: 6px;
                height: 6px;
                background: #F2F2F5;
                border-radius: 50%;
                margin-left: 6px;
            }

            .change_item_ac {
                background: #377CFD;
            }
        }

        /deep/.el-carousel {
            width: 100%;
            height: 100%;

            .el-carousel__container {
                width: 100%;
                height: 100%;

                .banner_box {
                    width: 100%;
                    height: 100%;
                    background-image: url('../../assets/img/index/legal/banner_bg2.png');
                    background-size: 100%;
                    padding-top: 88px;
                    .borders_box {
                        width: 160px;
                        height: 160px;
                        margin: auto;
                        border-radius: 50%;
                        // margin-top: 88px; 
                        // background: #FFFFFF;
                        // opacity: 0.2;
                        position: relative;

                        .borders1 {
                            width: 160px;
                            height: 160px;
                            background: #FFFFFF;
                            opacity: 0.2;
                            position: absolute;
                            left: 0;
                            top: 0;
                            z-index: 1;
                            border-radius: 50%;

                        }

                        .borders2 {
                            width: 132px;
                            height: 132px;
                            background: #C4C4C4;
                            position: absolute;
                            left: 50%;
                            top: 50%;
                            z-index: 2;
                            border-radius: 50%;

                            transform: translate(-50%, -50%);

                            img {
                                width: 132px;
                                height: 132px;
                                border-radius: 50%;

                            }
                        }

                        .tage_box {
                            width: 100%;
                            position: absolute;
                            z-index: 3;
                            bottom: -4px;
                            display: flex;
                            align-items: center;
                            justify-content: center;

                            .tages {
                                cursor: pointer;
                                width: 104px;
                                height: 32px;
                                background: linear-gradient(180deg, #FAECC6 0%, #F2CF85 100%);
                                border-radius: 16px 16px 16px 16px;
                                border: 1px solid #876052;
                                font-family: Microsoft YaHei, Microsoft YaHei;
                                font-weight: 400;
                                font-size: 14px;
                                color: #6C3E2D;
                                text-align: center;
                                line-height: 32px;
                            }
                        }

                    }

                    .ls_name {
                        padding-top: 28px;
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 24px;
                        color: #333333;
                        text-align: center;
                    }

                    .ls_texts {
                        padding-top: 14px;
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: 400;
                        font-size: 14px;
                        color: #666666;
                        text-align: center;
                    }

                    .btns_flex {
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        padding-top: 40px;

                        .btns {
                            width: 180px;
                            height: 40px;
                            background: #377CFD;
                            box-shadow: 0px 3px 6px 1px rgba(0, 0, 0, 0.16);
                            border-radius: 4px 4px 4px 4px;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            line-height: 40px;
                            text-align: center;
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: bold;
                            font-size: 14px;
                            color: #FFFFFF;
                            cursor: pointer;

                            img {
                                width: 14px;
                                height: 14px;
                                margin-right: 10px;
                            }
                        }
                    }
                }
            }

            .el-carousel__indicators {
                //  display: none;
            }
        }
    }
    .r_banner2{
        margin-top: 24px;
        width: 100%;
        height: 240px;
        background-image: url('../../assets/img/index/legal/r_top_bg2.png');
        background-size: 100%;
        .img_text{
            display: flex;
            align-items: center;
            font-family: Microsoft YaHei, Microsoft YaHei;
            font-weight: bold;
            font-size: 24px;
            color: #FFFFFF;
            display: flex;
            align-items: center;
            justify-content: center;
            padding-top: 48px;
            img{
                width:26px;
                margin-right: 12px;
            }
        }
        .textx1{
            padding-top: 13px;
            font-family: Microsoft YaHei, Microsoft YaHei;
            font-weight: 400;
            font-size: 14px;
            color: #FFFFFF;
            text-align: center;
        }
        .btns{
            margin: auto;
            margin-top: 40px;
            width: 180px;
            height: 40px;
            background: #FFFFFF;
            border-radius: 4px 4px 4px 4px;
            line-height: 40px;
            text-align: center;
            font-family: Microsoft YaHei, Microsoft YaHei;
            font-weight: bold;
            font-size: 14px;
            color: #377CFD;

        }
    }
    .r_banner3 {
        width: 420px;
        // height: 460px;
        height: 534px;
        // background: red;
        margin-top: 24px;
        position: relative;

        .banner_title {
            position: absolute;
            top: 24px;
            left: 32px;
            display: flex;
            align-items: center;
            z-index: 100;
            font-weight: bold;
            font-size: 18px;
            color: #333333;
        }

        .change_box {
            position: absolute;
            top: 32px;
            right: 32px;
            display: flex;
            align-items: center;
            z-index: 100;

            .change_item {
                width: 6px;
                height: 6px;
                background: #F2F2F5;
                border-radius: 50%;
                margin-left: 6px;
            }

            .change_item_ac {
                background: #377CFD;
            }
        }

        /deep/.el-carousel {
            width: 100%;
            height: 100%;

            .el-carousel__container {
                width: 100%;
                height: 100%;

                .banner_box {
                    width: 100%;
                    height: 100%;
                    // background-image: url('../../assets/img/index/legal/banner_bg2.png');
                    background: #FFFFFF;
                    background-size: 100%;
                    padding-top: 70px;
                    cursor: pointer;

                    .banner_imgs{
                        margin: auto;
                        width: 352px;
                        height: 260px;
                        img{
                            margin: auto;
                            width: 352px;
                            height: 260px;
                        }
                    }
                    .banner_texts{
                        padding:0 32px;
                        padding-top: 20px;
                        font-family: Microsoft YaHei, Microsoft YaHei;
                        font-weight: bold;
                        font-size: 18px;
                        color: #333333;

                    }
                    .banner_tages{
                        display: flex;
                        align-items: center;
                        padding:0 32px;
                        padding-top: 20px;

                        .teges{
                            padding: 4px 12px;
                            font-weight: 400;
                            font-size: 12px;
                            color: #FFAA00;
                            margin-right: 10px;
                            background: #FDF6EC;
                            border-radius: 3px 3px 3px 3px;
                            border: 1px solid #FFAA00;
                        }
                    }
                    .price_flex{
                        display: flex;
                        align-items: end;
                        padding:32px;

                        justify-content: space-between;
                        .prices{
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: bold;
                            font-size: 32px;
                            color: #FD4C5C;
                        }
                        .nums{
                            font-family: Microsoft YaHei, Microsoft YaHei;
                            font-weight: 400;
                            font-size: 16px;
                            color: #999999;
                        }
                    }

                     
                }
            }

            .el-carousel__indicators {
                //  display: none;
            }
        }
    }
    
}
</style>